/**
 * FairwayBid – Beschriftungen, die nicht umbrechen
 *
 * Im Filter links stand der Budgetrahmen als "15.000 bis 50.000 EUR". In der
 * schmalen Spalte bricht das um, und zwar an der schlechtesten Stelle: Der
 * Betrag steht in der ersten Zeile, die Währung allein in der zweiten. Eine
 * Zahl ohne ihre Einheit ist für einen Moment sinnlos, und das genügt, damit
 * eine Liste unruhig wirkt.
 *
 * Zwei Eingriffe, beide rein an der Darstellung – der gespeicherte Wert ist
 * der Optionsschlüssel und bleibt unberührt:
 *
 *   1. Kürzen. "5.000 bis 15.000 EUR" wird zu "5.000–15.000 €". Das ist ein
 *      Drittel schmaler und dieselbe Schreibweise, die auf der Startseite in
 *      den Anfragekacheln steht ("Budget 15.000–50.000 €"). Beides aus einer
 *      Quelle zu schreiben wäre schöner, aber die Kacheln kommen aus der
 *      Console und die Felder aus einem anderen Asset.
 *
 *   2. Zusammenhalten. Zwischen Zahl und Einheit steht ein geschütztes
 *      Leerzeichen. "50.000 €" kann damit nicht mehr getrennt werden – egal
 *      wie schmal die Spalte wird.
 *
 * Selbstheilend: Wer die Optionen in der Console gleich kurz schreibt,
 * merkt von dieser Datei nichts – die Regeln greifen dann einfach nicht.
 */

// Geschuetztes Leerzeichen als Escape und nicht als Zeichen: Im Quelltext
// waere es unsichtbar und beim naechsten Bearbeiten still verloren.
const NBSP = '\u00A0';
const HALBGEVIERTSTRICH = '\u2013';

/** Einheiten, die nie von ihrer Zahl getrennt werden dürfen. */
const EINHEITEN = [
  'EUR',
  'Stück',
  'Tag',
  'Tage',
  'Tagen',
  'Woche',
  'Wochen',
  'Monat',
  'Monate',
  'Monaten',
  'Jahr',
  'Jahre',
  'Jahren',
  'Stunden',
  'km',
  'kg',
  'ha',
];

const SPANNE = /(\d[\d.,]*)\s+bis\s+(\d[\d.,]*)/g;
const EINHEIT = new RegExp(`(\\d)\\s+(${EINHEITEN.join('|')})(?![\\wäöüß])`, 'g');
const WAEHRUNG = /(\d)\s*(?:EUR|€)/g;

/**
 * Eine Beschriftung, die in einer schmalen Spalte nicht auseinanderfällt.
 */
export const lesbareBeschriftung = roh => {
  if (typeof roh !== 'string') return roh;

  return roh
    .replace(SPANNE, `$1${HALBGEVIERTSTRICH}$2`)
    .replace(EINHEIT, `$1${NBSP}$2`)
    .replace(WAEHRUNG, `$1${NBSP}€`);
};

/**
 * Wendet die Regel auf die Optionsbeschriftungen aller Anzeigenfelder an.
 * Die Feldnamen selbst bleiben, wie sie sind – sie stehen über der Liste und
 * haben die ganze Spaltenbreite.
 */
export const mitLesbarenBetraegen = (listingFields = []) =>
  listingFields.map(feld =>
    Array.isArray(feld?.enumOptions)
      ? {
          ...feld,
          enumOptions: feld.enumOptions.map(o => ({
            ...o,
            label: lesbareBeschriftung(o?.label),
          })),
        }
      : feld
  );
